export enum CalendarEventTypes {
    Hours = -1,
    HoursWorked = -2,
    AddHours = -3,
    ActionItem = -4,
    RequestForLeaveHours = -5,
    BlankSpacer = -6,
    
    // background cell events...
    BgWorkdayCell = -7,
    BgNonWorkdayCell = -8,
    BgBlankCell = -9,
    BgBlankCellNoTitle = -10
}

export enum CalendarEventFlags {
    Warning = -1,
    Exhausted = -2
}